import moment from 'moment';
import { ApuracoesPontoService } from '../../apuracoesponto.service';
import { IApuracaoPonto } from '../../../models/apuracaoponto.model';
import {
    IApuracaoPontoHistorico,
    IApuracaoPontoHistoricoItemView
} from '../../../models/apuracaopontohistorico.model';

export class HistoricoApuracaoController {

    static $inject = ['ApuracoesPontoService'];

    public opened = false;
    public apuracao: IApuracaoPonto | null = null;
    public refreshKey = 0;
    public onClose?: () => void;

    public loading = false;
    public loadError = false;
    public items: IApuracaoPontoHistoricoItemView[] = [];

    constructor(
        public ApuracoesPontoService: ApuracoesPontoService,
    ) {}

    $onChanges(changes: angular.IOnChangesObject) {
        if (!this.opened || !this.apuracao?.apuracaoponto) {
            return;
        }

        const openedChanged = !!changes.opened && changes.opened.currentValue === true;
        const apuracaoChanged = this.hasApuracaoChanged(changes.apuracao);
        const refreshChanged = this.hasRefreshChanged(changes.refreshKey);

        if (openedChanged || apuracaoChanged || refreshChanged) {
            this.carregarHistorico();
        }
    }

    fechar() {
        if (this.onClose) {
            this.onClose();
        }
    }

    hasItems() {
        return !!this.items.length;
    }

    getSubtitle() {
        if (!this.apuracao) {
            return '';
        }

        return this.apuracao.titleaccordion || this.getApuracaoTitulo(this.apuracao);
    }

    private carregarHistorico() {
        if (!this.apuracao?.apuracaoponto) {
            return;
        }

        this.loading = true;
        this.loadError = false;
        this.items = [];

        this.ApuracoesPontoService.getHistoricos(this.apuracao.apuracaoponto)
            .then((historicos) => {
                this.loadError = false;
                this.items = this.transformarHistorico(historicos || []);
            })
            .catch(() => {
                this.loadError = true;
                this.items = [];
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private hasApuracaoChanged(change?: angular.IChangesObject<IApuracaoPonto | null>) {
        if (!change || change.isFirstChange()) {
            return false;
        }

        const previousId = change.previousValue?.apuracaoponto;
        const currentId = change.currentValue?.apuracaoponto;

        return previousId !== currentId;
    }

    private hasRefreshChanged(change?: angular.IChangesObject<number>) {
        return !!change && !change.isFirstChange() && change.currentValue !== change.previousValue;
    }

    private transformarHistorico(historicos: IApuracaoPontoHistorico[]) {
        return historicos.map((historico) => ({
            id: historico.apuracaopontohistorico,
            titulo: this.getHistoricoTitulo(historico.status),
            dataHora: this.formatarDataHoraHistorico(historico.created_at || historico.lastupdate),
            responsavel: historico.created_by?.nome || '',
            descricao: '',
            indicatorClass: this.getHistoricoIndicatorClass(historico.status),
        }));
    }

    private getHistoricoTitulo(status: number) {
        if (status === 1) {
            return 'Apuração fechada';
        }

        if (status === 0) {
            return 'Apuração reaberta';
        }

        return 'Status da apuração atualizado';
    }

    private getHistoricoIndicatorClass(status: number) {
        if (status === 1) {
            return 'indicator--success';
        }

        if (status === 0) {
            return 'indicator--warning';
        }

        return 'indicator--info';
    }

    private formatarDataHoraHistorico(data?: string | null) {
        if (!data) {
            return '';
        }

        return moment(data).format('DD/MM/YYYY [às] HH:mm');
    }

    private getApuracaoTitulo(apuracao: IApuracaoPonto) {
        const inicioapuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        const terminoapuracao = moment(apuracao.terminoapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');

        return `Apuração ${inicioapuracao} a ${terminoapuracao}${this.getReferenciaApuracao(apuracao)}`;
    }

    private getReferenciaApuracao(apuracao: IApuracaoPonto) {
        if (apuracao.trabalhadorobj?.trabalhador) {
            return ` - Trabalhador: ${apuracao.trabalhadorobj.nome} `;
        }

        if (apuracao.lotacaoobj?.lotacao) {
            return ` - Lotação: ${apuracao.lotacaoobj.nome} `;
        }

        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return ` - Estabelecimento: ${apuracao.estabelecimentoobj.nomefantasia} `;
        }

        if (apuracao.empresaobj?.empresa) {
            return ` - Empresa: ${apuracao.empresaobj.razaosocial} `;
        }

        return ' ';
    }
}
